import {
  Button,
  Checkbox,
  FormText,
  InputField,
  Label,
} from '@energybox/react-ui-library/dist/components';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { updateUserPassword } from '../../../actions/app';
import BaseFilterBar from '../../../components/Filters/BaseFilterBar';
import { ApplicationState } from '../../../reducers';
import styles from './ChangePasswordPage.module.css';

type Props = {
  userId: number;
  onSubmit: typeof updateUserPassword;
  didPasswordChangeFail: boolean;
};

const ChangePasswordPage: React.FunctionComponent<Props> = ({
  userId,
  onSubmit,
  didPasswordChangeFail,
}) => {
  const [state, setState] = useState({
    password: '',
    passwordRepeat: '',
  });

  const [showPassword, toggleShowPassword] = useState(false);
  const passwordMatches = state.password === state.passwordRepeat;
  const haveEnoughChars =
    state.password.length >= 6 && state.passwordRepeat.length >= 6;

  const onFormSubmit = (ev) => {
    ev.preventDefault();
    onSubmit(userId.toString(), state.password, state.passwordRepeat);
  };

  if (!userId) {
    return null;
  }

  return (
    <div>
      <BaseFilterBar />
      <form
        className={styles.formWrapper}
        autoComplete="new-password"
        onSubmit={onFormSubmit}
      >
        <h4>Change Password</h4>

        <div className={styles.inputWrapper}>
          <Label required>New Password</Label>
          <InputField
            autoComplete="new-password"
            type={!showPassword ? 'password' : 'text'}
            name="password"
            value={state.password}
            onChange={(ev) =>
              setState({
                password: ev.currentTarget.value,
                passwordRepeat: state.passwordRepeat,
              })
            }
            error={didPasswordChangeFail && !passwordMatches}
            customErrorText={' '}
          />
        </div>
        <div className={styles.inputWrapper}>
          <Label required>Confirm New Password</Label>
          <InputField
            autoComplete="new-password"
            type={!showPassword ? 'password' : 'text'}
            name="password-repeat"
            value={state.passwordRepeat}
            onChange={(ev) =>
              setState({
                passwordRepeat: ev.currentTarget.value,
                password: state.password,
              })
            }
            error={didPasswordChangeFail && !passwordMatches}
            customErrorText={"Passwords don't match"}
          />
        </div>
        <div>
          <Checkbox
            checked={showPassword}
            className={styles.formCheckbox}
            name="passwordToggle"
            label="Show Password"
            onChange={(e) => toggleShowPassword(!showPassword)}
            labelSize="small"
          />
        </div>
        <FormText>
          <div className={styles.passwordRequirementText}>
            The password must contain at least 12 characters, including at least
            1 uppercase, 1 lowercase and 1 special character.
          </div>
        </FormText>
        <div>
          <Button disabled={!haveEnoughChars} type="submit">
            Change Password
          </Button>
        </div>

        {didPasswordChangeFail && (
          <div className={styles.passwordChangeFail}>
            Password change failed. Try again.
          </div>
        )}
      </form>
    </div>
  );
};

const mapStateToProps = ({ app }: ApplicationState) => ({
  userId: app.currentUser ? app.currentUser.id : 0,
  didPasswordChangeFail: app.didPasswordChangeFail,
});

const mapDispatchToProps = {
  onSubmit: updateUserPassword,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordPage);
